import Ajax from './core/Ajax'
import { removeCookie } from '@/utils/cookie'
import getConfig from 'next/config'
import { localStorageService } from "@/utils/storageService"

const { publicRuntimeConfig } = getConfig()
const apiDomain = publicRuntimeConfig.apiDomain

//创建网络实体对象
const createAjaxInstance = (options?: any) => {
  return new Ajax({ timeout: 30000, withCredentials: true, ...options })
}

//业务网络对象
export const ajax = createAjaxInstance()

//刷新token使用(不走拦截器,避免循环问题)
export const fetch = createAjaxInstance()

//请求拦截器
ajax.axiosInstance.interceptors.request.use(
  async (config: any) => {
    const url = config.url
    var regex = /\/viewcart\/(ajaxaddcart|addtocart)/;
    console.log(regex.test(url));
    
    // 设置请求header
    const customHeader = {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': regex.test(url) ? 'application/x-www-form-urlencoded' : 'application/json',
      'Accept': '*/*',
      'Authorization': localStorageService.getItem('userToken')
    }
    config.headers = Object.assign({}, config.headers, customHeader)    
    return config
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

//响应拦截器
ajax.axiosInstance.interceptors.response.use(
  (response: any) => {
    try {
      if (
        (response.status == 200 || response.status == 201)
      ) {
        if (response.data.code <= 100000) {
          return Promise.resolve(response.data)
        } else {
          // 设配老版加入购物车api，后续改版后去掉
          const url = response.config.url
          var regex = /\/viewcart\/(ajaxaddcart|ajaxaddlocaltocart|addtocart|ajaxAddLocalCart|batchAddToCart)/;
          if (regex.test(url)) {
            return Promise.resolve(response.data)
          }
          return Promise.reject(response.data)
        }
      }

      return Promise.reject(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  (error: any) => {
    if (error.response.status == 401) {
      removeCookie('PHPSESSID')
      const currentPath = window.location.pathname;
      window.location.href = `${apiDomain}/login?redirect=${currentPath}`

      return Promise.reject(error.response.data)
    }
    return Promise.reject(error.response.data)
  }
)

export default {
  ajax,
  fetch
}
